import styles from "./styles.module.scss";
import InputWrapper from '../../../modules/molecules/InputWrapper';
import { Button } from 'gf-ui-components-mui-lib';
import { useResetPassword } from './useResetPassword';
import { FormikProvider } from 'formik';
import AuthLayout from '../Login/components/AuthLayout';

const ResetPassword = () => {
    const { restFormik, handleResetPassword } = useResetPassword();

    return (
        <FormikProvider value={restFormik}>
            <AuthLayout>
                <div>
                    <span className={`${styles['subtitle']}`} data-testid="reset-password-subtitle">Reset Password</span>
                </div>
                <div className={styles.inputContainer}>
                    <InputWrapper
                        {...{
                            label: 'Password',
                            name: 'password',
                            placeholder: 'Enter password',
                            type: 'password'
                        }}
                    />
                    <InputWrapper
                        {...{
                            label: 'Confirm Password',
                            name: 'confirmPassword',
                            placeholder: 'Enter confirm password',
                            type: 'password'
                        }}
                    />
                </div>
                <div className={styles.bottomContainer}>
                    <Button
                        id="reset-btn"
                        disabled={!(restFormik?.isValid && restFormik?.dirty)}
                        className={styles.resetBtn} onClick={handleResetPassword}>
                        Reset
                    </Button>
                </div>
            </AuthLayout>
        </FormikProvider>
    )
}

export default ResetPassword;